import * as fromDatatype from '../datatype-library/index';

export interface bl_bi_report_query_event_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  report_hdr_guid: fromDatatype.GuidDataFieldInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  effective_date: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  duration_day: fromDatatype.IntegerDatatypeInterface;
  logic_execution: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  posting_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  is_recurring: fromDatatype.VarcharDatatypeInterface;
  recurring_event_params: fromDatatype.JsonDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  recurring_posting_status: fromDatatype.VarcharDatatypeInterface;
  recurring_posting_error: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_bi_report_query_event_hdr_RowClass
  implements bl_bi_report_query_event_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  report_hdr_guid: fromDatatype.GuidDataFieldInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  effective_date: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  duration_day: fromDatatype.IntegerDatatypeInterface;
  logic_execution: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  posting_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  is_recurring: fromDatatype.VarcharDatatypeInterface;
  recurring_event_params: fromDatatype.JsonDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  recurring_posting_status: fromDatatype.VarcharDatatypeInterface;
  recurring_posting_error: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
